import { render, staticRenderFns } from "./blank-layout.vue?vue&type=template&id=7962c26f&scoped=true&lang=pug&"
import script from "./blank-layout.vue?vue&type=script&lang=ts&"
export * from "./blank-layout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7962c26f",
  null
  
)

export default component.exports